import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

import PageTitle from './Title';
import PageParagraph from './Paragraph';

const { node, string } = PropTypes;

/**
 * Page
 *
 * This component is in charge of displaying
 * a page
 *
 * @param {string} children // Anything that can be rendered: numbers, strings, elements or an array (or fragment).
 * @param {string} className // className needed by styled components.
 *
 * @return {jsx}
 */

class Page extends Component {
  static Title = PageTitle;
  static Paragraph = PageParagraph;

  /**
   * PropTypes validation
   */
  static propTypes = {
    className: string,
    children: node,
  };

  /**
   * Default propTypes
   */
  static defaultProps = {
    className: '',
    children: null,
  };

  /**
   * Render function
   */
  render() {
    const { className, children } = this.props;

    return <div className={className}>{children}</div>;
  }
}

export default styled(Page)`
  padding: 2.4rem 3rem 3.4rem;

  ${({ textCenter }) => textCenter && 'text-align: center'};

  /* For small devices */
  ${breakpoint('xs', 'md')`
    height: 100%;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/Page/index.js